import(/* webpackMode: "eager" */ "/root/tekyerde-frontend/app/(commerce)/page.tsx");
